// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"explainer_logoWrapper__nEGh2","icon":"explainer_icon__r0FsY","subtitle":"explainer_subtitle__JHRrt","title":"explainer_title__BXLtT","text":"explainer_text__U24qO"};